export enum TrueFalse {
  True = 'true',
  False = 'false',
}
